import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Charts } from '@/_shared/components/Charts';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { getSurveyCampaignByIdResponsesResultsStatsCall } from '@/surveys/state/api';

export const DistributionBox = () => {
  const t = useTranslations('department.details.assessment.distributionBox');
  const { teamStats } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();

  const { isDesktop } = useBreakingPoints();

  return (
    <Box>
      <Typography variant='h3' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='l'>
        {t('descriptionTeam')}
      </Typography>
      <Charts.StackedBarChartComponent
        total={teamStats?.totalCompletedSurveys || 0}
        data={teamStats?.metricsScore || []}
        defaultItemsSize={isDesktop ? 6 : 2}
      />
    </Box>
  );
};
